var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_8511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 15.108V12.0156C5 10.3588 6.34315 9.01562 8 9.01562C9.65685 9.01562 11 10.3588 11 12.0156V15.108",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 7.73048V13.4096C0.75 14.426 1.56148 15.25 2.5625 15.25H13.4375C14.4385 15.25 15.25 14.426 15.25 13.4096V7.73048C15.25 7.24237 15.059 6.77426 14.7191 6.42911L9.92245 1.55857C8.86071 0.480479 7.13929 0.480477 6.07756 1.55856L1.28087 6.42911C0.940959 6.77426 0.75 7.24237 0.75 7.73048Z",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_8511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarDashboardIcon);
export default __webpack_public_path__ + "static/media/sidebar-dashboard-icon.f6ac02d65ab966dc8ec67c4fa2f1aacf.svg";
export { ForwardRef as ReactComponent };